import tcglandSidebar1 from '@/assets/ads/tcg.land/160x600/160x600-1.jpg'
import tcglandSidebar2 from '@/assets/ads/tcg.land/160x600/160x600-2.jpg'
import tcglandSidebar3 from '@/assets/ads/tcg.land/160x600/160x600-3.jpg'
import tcglandSidebar4 from '@/assets/ads/tcg.land/160x600/160x600-4.jpg'
import tcglandSidebar5 from '@/assets/ads/tcg.land/160x600/160x600-5.jpg'
import tcglandSidebar6 from '@/assets/ads/tcg.land/160x600/160x600-6.jpg'
import tcglandSidebar7 from '@/assets/ads/tcg.land/160x600/160x600-7.jpg'
import tcglandSidebar8 from '@/assets/ads/tcg.land/160x600/160x600-8.jpg'
import tcglandMobile1 from '@/assets/ads/tcg.land/320x50/320x50-1.jpg'
import tcglandMobile2 from '@/assets/ads/tcg.land/320x50/320x50-2.jpg'
import tcglandMobile3 from '@/assets/ads/tcg.land/320x50/320x50-3.jpg'
import tcglandMobile4 from '@/assets/ads/tcg.land/320x50/320x50-4.jpg'
import tcglandMobile5 from '@/assets/ads/tcg.land/320x50/320x50-5.jpg'
import tcglandMobile6 from '@/assets/ads/tcg.land/320x50/320x50-6.jpg'
import tcglandMobile7 from '@/assets/ads/tcg.land/320x50/320x50-7.jpg'
import tcglandMobile8 from '@/assets/ads/tcg.land/320x50/320x50-8.jpg'
import tcglandDesktop1 from '@/assets/ads/tcg.land/728x90/728x90-1.jpg'
import tcglandDesktop2 from '@/assets/ads/tcg.land/728x90/728x90-2.jpg'
import tcglandDesktop3 from '@/assets/ads/tcg.land/728x90/728x90-3.jpg'
import tcglandDesktop4 from '@/assets/ads/tcg.land/728x90/728x90-4.jpg'
import tcglandDesktop5 from '@/assets/ads/tcg.land/728x90/728x90-5.jpg'
import tcglandDesktop6 from '@/assets/ads/tcg.land/728x90/728x90-6.jpg'
import tcglandDesktop7 from '@/assets/ads/tcg.land/728x90/728x90-7.jpg'
import tcglandDesktop8 from '@/assets/ads/tcg.land/728x90/728x90-8.jpg'

const getRandomAd = (key: string) => {
  const images =
    key === 'tcg.land/sidebar'
      ? [
          tcglandSidebar1,
          tcglandSidebar2,
          tcglandSidebar3,
          tcglandSidebar4,
          tcglandSidebar5,
          tcglandSidebar6,
          tcglandSidebar7,
          tcglandSidebar8,
        ]
      : key === 'tcg.land/mobile'
        ? [
            tcglandMobile1,
            tcglandMobile2,
            tcglandMobile3,
            tcglandMobile4,
            tcglandMobile5,
            tcglandMobile6,
            tcglandMobile7,
            tcglandMobile8,
          ]
        : [
            tcglandDesktop1,
            tcglandDesktop2,
            tcglandDesktop3,
            tcglandDesktop4,
            tcglandDesktop5,
            tcglandDesktop6,
            tcglandDesktop7,
            tcglandDesktop8,
          ]
  const randomIndex = Math.floor(Math.random() * images.length)
  return images[randomIndex]
}

export default getRandomAd
